export default __webpack_public_path__ + "static/media/nov2023-1.d6afd386.jpg";